import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const removeQueryString = (origin: string): string => {
    let url: URL;
    try {
        url = new URL(origin);
    } catch {
        return '';
    }
    return url.origin + url.pathname;
};

export function inIframe(): boolean {
    return window.self !== window.top;
}
